import { ChangeDetectionStrategy, Component, input } from '@angular/core';

let instanzZaehler = 0;

@Component({
  selector: 'app-konto-sektion',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './konto-sektion.component.html',
  styleUrl: './konto-sektion.component.scss',
})
export class KontoSektionComponent {
  readonly titel = input.required<string>();
  readonly untertitel = input<string>('');

  protected readonly titelId = `konto-sektion-titel-${++instanzZaehler}`;
}
